import React from 'react';
import '../App.css';
import { useTranslation } from 'react-i18next';

const PrivacyPolicy = () => {
    const { t } = useTranslation();

    return (
        <div className="page_container container">
            <div className="admin-wrapper" style={{ minHeight: '60vh' }}>
                <p>{t("Privacy Policy Title")}</p>
                <div className="content_page">
                    <p><i>{t("General provisions")}</i></p>
                    <p>{t("General provisions text")}</p>

                    <p><i>{t("Data collection title")}</i></p>
                    <p>{t("Data collection text")}</p>

                    <p><i>{t("Data protection title")}</i></p>
                    <p>{t("Data protection text")}</p>

                    <p><i>{t("Third-party transfer title")}</i></p>
                    <p>{t("Third-party transfer text")}</p>

                    <p><i>{t("User rights title")}</i></p>
                    <p>{t("User rights text")}</p>

                    <p><i>{t("Policy changes title")}</i></p>
                    <p>{t("Policy changes text")}</p>

                    <p className="mini">
                        {t("Last updated")}: {new Date().toLocaleDateString()}
                    </p>
                    <br/>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
